module.exports = __webpack_public_path__ + "media/components/assets/images/sseobolgga/image8_3_sub2-f19294a592498aefd4e69104a42660a2.png";